<div kalDialogHeader>
    <div class="kal-dialog__title">Créer un avoir - Facture n°{{ invoice.NumFacture }}</div>
</div>

<div [formGroup]="form"
     [kalLoading]="loading"
     kalDialogContent>
    <div class="creditDialog__container">
        <p class="gup-U-color--orange" *ngIf="creditLabel">{{ creditLabel }}</p>

        <kal-form-field class="creditDialog__date">

            <kal-datepicker formControlName="DateFact"
                            label="Date de génération de l'avoir">
            </kal-datepicker>

        </kal-form-field>

        <div class="creditDialog__type">

            <kal-form-field>

                <kal-radio-group formControlName="Type"
                                 label="Type d'avoir">

                    <kal-radio value="amount">En montant</kal-radio>
                    <kal-radio value="percent">En pourcentage</kal-radio>

                </kal-radio-group>

            </kal-form-field>

            <kal-form-field class="without-label">

                <kal-input [icon]="type === 'amount' ? 'euro' : '%'"
                           [type]="type === 'amount' ? 'number' : 'currency'"
                           formControlName="Amount">
                </kal-input>

            </kal-form-field>

        </div>

        <ng-container *ngIf="canImpute">
            <div class="creditDialog__switch">

                <kal-checkbox [label]="'Imputer l\'avoir sur la facture n°' + invoice.NumFacture"
                              formControlName="IsImputeAvoirSurFact"
                              kalTheme="switch">
                </kal-checkbox>

            </div>

            <p class="small gup-U-color--400">
                Si l'avoir n'est pas imputé sur cette facture, alors il sera enregistré et
                pourra être utilisé pour régler une autre facture ou être remboursé au bénéficiaire.
            </p>
        </ng-container>

        <kal-form-field *ngIf="invoice.IdFournisseur">

            <kal-input formControlName="NumeroAvoir"
                       label="Numéro de l'avoir">
            </kal-input>

        </kal-form-field>

        <kal-form-field class="creditDialog__journal">

            <kal-select formControlName="IdJournal"
                        label="Journal">

                <kal-option *ngFor="let journal of journalsList"
                            [value]="journal.IdJournal">
                    {{ journal.LibelleJournal }}
                </kal-option>

            </kal-select>

        </kal-form-field>

        <kal-form-field class="creditDialog__exercice">

            <kal-select formControlName="IdExercice"
                        label="Exercice concerné">

                <kal-option *ngFor="let exercice of exercicesList"
                            [value]="exercice.IdExercice">
                    {{ exercice.CodeExercice }}
                </kal-option>

            </kal-select>

        </kal-form-field>

        <app-shared-comment-edit formControlName="Comment">
        </app-shared-comment-edit>
    </div>
</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        [disabled]="form.invalid || loading"
                        kalTheme="primary">
                Créer un avoir
            </kal-button>
        </div>

        <div class="gup-O-list__item">
            <kal-button (click)="close()"
                        kalTheme="secondary">
                Annuler
            </kal-button>
        </div>

    </div>

</div>
